import AuthService from "@/services/AuthService.js";
import { ls } from "@/utilities";

export default {
  namespaced: true,
  state: {
    errors: null,
    loading: false,
    user: null,
    registerOtpToken: null,
    token: null,
    rememberMe: null,
    guestToken: null,
    ssoToken: null,
    socialSsoAuthCancelled: false
  },
  mutations: {
    SET_LOADING(state, value) {
      state.loading = value;
    },
    SET_ERRORS(state, errors) {
      state.errors = errors;
    },
    RESET_ERRORS(state) {
      state.errors = null;
    },
    SET_USER_DATA(state, userData) {
      state.user = userData;
      ls.set("user", JSON.stringify(userData));
      state.rememberMe !== null
        ? localStorage.setItem(
            "mobileNumber",
            JSON.stringify(userData.customer.mobile_number)
          )
        : localStorage.removeItem("mobileNumber");
    },
    CLEAR_USER_DATA() {
      localStorage.removeItem("user");
      location.reload();
    },
    SET_REGISTER_OTP_TOKEN(state, registerOtpToken) {
      state.registerOtpToken = registerOtpToken;
    },
    SET_TOKEN(state, token) {
      state.token = token;
      ls.set("token", token);
    },
    CLEAR_TOKEN() {
      localStorage.removeItem("token");
    },
    SET_REMEMBER_ME(state, rememberMe) {
      state.rememberMe = rememberMe;
    },
    SET_SSO_TOKEN(state, ssoToken) {
      state.ssoToken = ssoToken;
      if (ssoToken) {
        ls.set("ssoToken", ssoToken);
      } else {
        ls.remove("ssoToken");
      }
    },
    setGuestToken(state, payload) {
      state.guestToken = payload;
    }
  },
  actions: {
    async resetErrors({ commit }) {
      commit("RESET_ERRORS");
    },
    async register({ commit }, request) {
      commit("SET_LOADING", true);
      try {
        let response = await AuthService.register(request);
        commit("SET_REGISTER_OTP_TOKEN", response.token);
        commit("SET_LOADING", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
      }
    },
    async login({ commit }, request) {
      commit("SET_LOADING", true);
      try {
        request.rememberMe === true
          ? commit("SET_REMEMBER_ME", request.payload.mobile_number)
          : commit("SET_REMEMBER_ME", null);
        let response = await AuthService.login(request);
        commit("SET_USER_DATA", response);
        commit("SET_TOKEN", response.token);
        if (response.sso_token && response.sso_token.token) {
          commit("SET_SSO_TOKEN", response.sso_token.token);
        }
        commit("SET_LOADING", false);
      } catch (errors) {
        if (
          [
            "Sorry account is not found",
            "Invalid mobile number or pin"
          ].includes(errors.errors.message)
        ) {
          commit("SET_ERRORS", {
            errors: {
              mobile_number: errors.errors.message
            }
          });
        } else if (
          errors.errors.message ==
          "It seems that you still didn't set your pin. Please set it via forgot pin."
        ) {
          commit("SET_ERRORS", {
            errors: {
              mpin: errors.errors.message
            }
          });
        } else {
          commit("SET_ERRORS", errors);
        }
        commit("SET_LOADING", false);
      }
    },
    logout({ commit }) {
      commit("CLEAR_TOKEN");
      commit("CLEAR_USER_DATA");
      commit("setGuestToken", null);
      commit("SET_SSO_TOKEN", null);
      ls.remove("guestToken");
    },
    async getPublicCustomerToken({ commit }, request) {
      commit("SET_LOADING", true);
      commit("SET_ERRORS", null);

      try {
        const { data } = await AuthService.getPublicCustomerToken(request);
        commit("setGuestToken", data.token);
        ls.set("guestToken", data.token);
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("SET_LOADING", false);
      }
    }
  },
  getters: {
    loggedIn(state) {
      return !!state.user;
    },
    user(state) {
      return state.user;
    },
    isAuthenticated: state => !!state.token,
    ssoToken: state => state.ssoToken || ls.get("ssoToken") || null,
    guestToken: state =>
      state.guestToken ? state.guestToken : ls.get("guestToken")
  }
};
